<div class="flex-col flex h-full media-gallery-dialog-container" style="font-family: 'Open Sans';"
  *ngIf="filteredMedia$ | async as media">
  <div class="relative flex flex-row items-center justify-between mb-4">
    <div class="text-lg font-semibold">Media Gallery</div>
    <div class="flex flex-row items-center">
      <div *ngIf="data.showFilter" (shaClickOutside)="isPopoverOpen = false">
        <button mat-icon-button (click)="isPopoverOpen = !isPopoverOpen" class="filter-button mr-5">
          <mat-icon>filter_list</mat-icon>
        </button>
        <div *ngIf="isPopoverOpen">
          <div class="absolute right-10 top-10 z-10 bg-white rounded-md px-5 py-4 shadow-lg">
            <form class="flex flex-col" id="mediaFilterForm" [formGroup]="mediaFilterForm">
              <div class="flex flex-col">
                <span class="font-semibold text-xs mb-1" style="font-family: 'Open Sans'; color: #282828">
                  Work Order ID</span>
                <mat-form-field appearance="outline" class="text-xs w-32 sm:w-auto">
                  <input id="workOrderId" matInput formControlName="workOrderId" type="number" inputmode="numeric"
                    autocomplete="off">
                  <mat-error *ngIf="mediaFilterForm.get('workOrderId').hasError('pattern')">
                    Must be a number.
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="w-full flex justify-center">
                <span class="pl-2">- or -</span>
              </div>
              <div class="flex flex-col">
                <span class="font-semibold text-xs mb-1 mt-3"
                  style="font-family: 'Open Sans'; color: #282828">Appointment
                  ID</span>
                <mat-form-field appearance="outline" class="text-xs w-32 sm:w-auto">
                  <input id="appointmentId" matInput formControlName="appointmentId" type="number" inputmode="numeric"
                    autocomplete="off">
                  <mat-error *ngIf="mediaFilterForm.get('appointmentId').hasError('pattern')">
                    Must be a number.
                  </mat-error>
                </mat-form-field>
              </div>
              <mat-error class="flex w-full justify-center text-xs mb-2"
                *ngIf="mediaFilterForm.errors?.multipleFieldsSubmitted">
                Please only submit one field.
              </mat-error>
              <div class="w-full flex justify-center">
                <button (click)="applyFilter(mediaFilterForm.value)"
                  class="flex place-items-center place-content-center py-2.5 px-5 rounded-md cursor-pointer"
                  style="background: 'rgba(0, 84, 166, 1)'; font-family: 'Open Sans'; height: 34px"
                  [disabled]="mediaFilterForm.invalid">
                  <span class="text-white font-medium text-xs">Apply</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div (click)="cancel()" class="cursor-pointer">
        <svg width="16" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M7.17188 7.5L9.51562 9.86719C9.82031 10.1484 9.82031 10.6172 9.51562 10.8984L9 11.4141C8.71875 11.7188 8.25 11.7188 7.96875 11.4141L5.625 9.07031L3.25781 11.4141C2.97656 11.7188 2.50781 11.7188 2.22656 11.4141L1.71094 10.8984C1.40625 10.6172 1.40625 10.1484 1.71094 9.86719L4.05469 7.5L1.71094 5.15625C1.40625 4.875 1.40625 4.40625 1.71094 4.125L2.22656 3.60938C2.50781 3.30469 2.97656 3.30469 3.25781 3.60938L5.625 5.95312L7.96875 3.60938C8.25 3.30469 8.71875 3.30469 9 3.60938L9.51562 4.125C9.82031 4.40625 9.82031 4.875 9.51562 5.15625L7.17188 7.5Z"
            fill="#181A18" />
        </svg>
      </div>
    </div>
  </div>
  <mat-dialog-content>
    <sha-media-gallery [media]="media"></sha-media-gallery>
  </mat-dialog-content>
</div>